"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Chip.scss");
var ChipState;
(function (ChipState) {
    ChipState["SUCCESS"] = "success";
    ChipState["DANGER"] = "danger";
    ChipState["INFO"] = "info";
})(ChipState = exports.ChipState || (exports.ChipState = {}));
var Chip = function (_a) {
    var dot = _a.dot, label = _a.label, dusk = _a.dusk, _b = _a.state, state = _b === void 0 ? ChipState.INFO : _b, className = _a.className;
    var classes = ['chip'];
    if (state) {
        classes.push("chip--" + state);
    }
    if (dot) {
        classes.push('chip--dotted');
    }
    if (className) {
        classes.push(className);
    }
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: classes.join(' ') }, label));
};
exports.default = Chip;
//# sourceMappingURL=index.js.map